//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import theme from './FilterList.scss';
import ListWithHeader from 'common/components/core/list/ListWithHeader';
import { UIFilter } from 'common/models/internal/UIFilter';
import Filter from './Filter';

type Props = {
    className?: string,
    title?: ?string,
    filters: Array<UIFilter>,
    appliedFilters: Object,
    defaultCountryISOCode: string,
    theme: Object,
    onChange: (value: string) => void
};
class FilterList extends React.PureComponent<Props> {
    static defaultProps = {};

    onChange = ({ id, value, idList }) => {
        const { onChange, appliedFilters } = this.props;
        onChange({
            ...appliedFilters,
            [id]: {
                id,
                value,
                idList,
                isFilterApplied: value.length > 0 || value === true
            }
        });
    };

    render() {
        const { title, filters, appliedFilters, theme, className } = this.props;
        return (
            <ListWithHeader title={title} theme={theme} className={className}>
                {filters.map(filter => {
                    return (
                        <Filter
                            theme={theme}
                            key={filter.id}
                            filter={filter}
                            appliedFilter={appliedFilters[filter.id]}
                            onChange={this.onChange}
                        />
                    );
                })}
            </ListWithHeader>
        );
    }
}

const ThemedFilterList = themr('FilterList', theme)(FilterList);

export { ThemedFilterList as FilterList };
export default ThemedFilterList;
